import { Box, Typography } from '@mui/material'
import React from 'react'
import { CheckCircle, XCircle } from 'react-feather'

export const RequirementStatus = (props) => {

  const {
    message,
    requirement_status,
  } = props

  const color = (requirement_status) ? 'green' : 'red'
  return (
    <Box 
      display="flex" 
      alignItems="center" 
      justifyContent="space-between" 
      p={2} 
      borderRadius={2}
      border={`1px solid ${color}`}
    >
      <Box display="flex" alignItems="center">
        {requirement_status ? (
          <CheckCircle color={color} size={32} />
        ) : (
          <XCircle color={color} size={32} />
        )}

        <Typography variant="body1" color={color} ml={2}>
          {message}
        </Typography>
      </Box>
    </Box>
  )
}
